/** 조기폐차 UI 노출 여부 (당분간 숨김) */
export const IS_EARLY_SCRAP_UI_ENABLED = false;

const PerformanceCheckKind = {
  PSEUDO: 'P', // 가성능
  NEW: 'N', // 신규점검
  RECHECK: 'Y', // 재점검
  EARLY_SCRAP: 'E', // 조기폐차 (서버/DB 미적용)
};

const PERFORMANCE_CHECK_KIND_LABELS = {
  [PerformanceCheckKind.PSEUDO]: '가성능',
  [PerformanceCheckKind.NEW]: '신규점검',
  [PerformanceCheckKind.RECHECK]: '재점검',
  [PerformanceCheckKind.EARLY_SCRAP]: '조기폐차',
};

const PERFORMANCE_CHECK_KIND_TAG_CLASS = {
  [PerformanceCheckKind.PSEUDO]: 'bg-purple-400',
  [PerformanceCheckKind.NEW]: 'bg-cyan-400',
  [PerformanceCheckKind.RECHECK]: 'bg-orange-400',
  [PerformanceCheckKind.EARLY_SCRAP]: 'bg-gray-500',
};

export const resolvePerformanceCheckKind = (row) => {
  const { checkKind, isRecheck } = row ?? {};

  if (checkKind && PERFORMANCE_CHECK_KIND_LABELS[checkKind]) {
    return checkKind;
  }

  if (isRecheck === PerformanceCheckKind.PSEUDO) {
    return PerformanceCheckKind.PSEUDO;
  }

  if (isRecheck === PerformanceCheckKind.EARLY_SCRAP) {
    return PerformanceCheckKind.EARLY_SCRAP;
  }

  return isRecheck === 'Y'
    ? PerformanceCheckKind.RECHECK
    : PerformanceCheckKind.NEW;
};

export const isPseudoPerformanceCheck = (row) =>
  resolvePerformanceCheckKind(row) === PerformanceCheckKind.PSEUDO;

export const getPerformanceCheckKindLabel = (row) =>
  PERFORMANCE_CHECK_KIND_LABELS[resolvePerformanceCheckKind(row)];

export const getPerformanceCheckKindTagClass = (row) =>
  PERFORMANCE_CHECK_KIND_TAG_CLASS[resolvePerformanceCheckKind(row)];

Object.freeze(PerformanceCheckKind);

export default PerformanceCheckKind;
